// extracted by mini-css-extract-plugin
module.exports = {"colorFontPrimary":"#333","component":"_3HExdqRQLteiNVRFJAc-AA","hidden":"CgplyHM8ifW4OsvYgsjBb"};